import * as i0 from '@angular/core';
import { Component } from '@angular/core';
import { BaseIcon } from 'primeng/baseicon';
let BlankIcon = /*#__PURE__*/(() => {
  class BlankIcon extends BaseIcon {
    static ɵfac = /* @__PURE__ */(() => {
      let ɵBlankIcon_BaseFactory;
      return function BlankIcon_Factory(__ngFactoryType__) {
        return (ɵBlankIcon_BaseFactory || (ɵBlankIcon_BaseFactory = i0.ɵɵgetInheritedFactory(BlankIcon)))(__ngFactoryType__ || BlankIcon);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BlankIcon,
      selectors: [["BlankIcon"]],
      standalone: true,
      features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
      decls: 2,
      vars: 0,
      consts: [["width", "14", "height", "14", "viewBox", "0 0 14 14", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", "v-bind", "pti()"], ["width", "1", "height", "1", "fill", "currentColor", "fill-opacity", "0"]],
      template: function BlankIcon_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(0, "svg", 0);
          i0.ɵɵelement(1, "rect", 1);
          i0.ɵɵelementEnd();
        }
      },
      encapsulation: 2
    });
  }
  return BlankIcon;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { BlankIcon };
